module.exports = __webpack_public_path__ + "img/icon-checkbox-solid.63437040.svg";